var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav-tab"},_vm._l((_vm.tabs),function(title,key){return _c('a',{key:key,staticClass:"nav-item f-s-4 m-r-3 m-l-3",class:{'nav-item--active': _vm.active === key },attrs:{"href":'#' + key},on:{"click":function($event){$event.preventDefault();return _vm.switchActive(key)}}},[_vm._v(_vm._s(title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }